import requestApi from '@/services/requestApi';
import { Select } from 'antd';
import _ from 'lodash';
import { useEffect, useState } from 'react';
import { useController, useFormContext, useWatch } from 'react-hook-form';
import { createSelectOptions } from './createSelectOptions';

export function FormSearchInput({
  id,
  property,
  name,
  optionUrl,
  placeholder = 'Selecione',
  disabled,
  inputValueName,
  isClearable,
  onChangeCallback,
  itemChangeValidation,
  label,
  queryParamsOptions = '',
  valueProperty = 'id',
  optionStatic,
  sortOptions,
}: any) {
  const [options, setOptions] = useState<any>([]);
  const [loading, setLoading] = useState(false);
  const [firstLoad, setFirstLoad] = useState(true);

  const { setValue, control } = useFormContext();

  const inputValue = useWatch({ name: inputValueName, control });

  const {
    field: { onChange, value },
    fieldState: { error },
  } = useController({
    name,
    control,
  });

  const selectedValue =
    options.find((option: any) => option.value === value) || null;

  async function fetchOptions({ fetchPage = false }: any) {
    if (!firstLoad && !fetchPage) {
      return;
    }

    if (optionStatic) {
      setOptions(optionStatic);
      return;
    }

    setLoading(true);
    const {
      data,
      data: { content: optionsResult },
    } = await requestApi.get(optionUrl);
    setLoading(false);

    const allOptions = _.cloneDeep(options);

    const newOptions = createSelectOptions(
      optionsResult || data,
      property,
      valueProperty
    );

    newOptions.forEach(
      (newOption: any) =>
        !allOptions.find((option: any) => option.value === newOption.value) &&
        allOptions.push(newOption)
    );

    setOptions(allOptions);

    if (firstLoad) {
      setFirstLoad(false);
    }
  }

  async function fetchInputValue() {
    if (optionStatic && optionStatic.length === 0) {
      return;
    }
    let data: any;
    let selected: any;
    setLoading(true);
    if (optionStatic) {
      setOptions(optionStatic);
      data = optionStatic;
      selected = data.find((option: any) => option[valueProperty] === value) || null;
    } else {
      data = await requestApi.get(`${optionUrl}`);
      selected = data?.data?.find((option: any) => option[valueProperty] === value) || null;
    }
    setLoading(false);

    setOptions(data);
    const allOptions = _.cloneDeep(options);

    const newOptions = createSelectOptions([selected], property, valueProperty);

    newOptions.forEach((newOption: any) => allOptions.push(newOption));

    setOptions(allOptions);
  }

  useEffect(() => {
    if (value && !selectedValue) {
      fetchInputValue();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  const handleChange = (value: any, option: any) => {
    if (itemChangeValidation) {
      const valid = itemChangeValidation(value);
      if (!valid) {
        return;
      }
    }
    inputValueName && setValue(inputValueName, option?.label);

    onChange(value);
    onChangeCallback?.(value);
  };

  const filterOption = (
    input: string,
    option?: { label: string; value: string }
  ) => {
    const label = option?.label ?? '';
    const inputLower = input.toLowerCase();
  
    // Verificar se a label é numérica
    const isLabelNumeric = !isNaN(Number(label));
    const isInputNumeric = !isNaN(Number(input));
  
    if (isLabelNumeric && isInputNumeric) {
      // Comparar valores numéricos
      return label.toString().includes(inputLower);
    } else {
      // Comparar valores de string
      return label.toString().toLowerCase().includes(inputLower);
    }
  };

  const displayedOptions = sortOptions
    ? [...options].sort(sortOptions)
    : options;

  return (
    <>
      {label && <label htmlFor={id}>{label}</label>}
      <Select
        disabled={disabled}
        loading={loading}
        onChange={handleChange}
        onFocus={fetchOptions}
        value={selectedValue}
        id={id}
        options={displayedOptions}
        allowClear={isClearable}
        notFoundContent="Não há dados!"
        style={{ width: '100%', height: '2.5rem', marginTop: '5px'}}
        placeholder={placeholder}
        showSearch
        filterOption={filterOption}
      />
      {error && <span className="color-red">{error?.message}</span>}
    </>
  );
}